

window.addEventListener("load", function () {
    const btnView = document.querySelector('#pwm-ld-25-bigupdate-rank .btn_view');
    const footer = document.querySelector('#pwm-ld-25-bigupdate-rank footer');
    
    if (btnView && footer) {
        btnView.addEventListener('click', function() {
            footer.classList.toggle('active');
            btnView.classList.toggle('active');
        });
    }
});
